import { Button, ConfigProvider, Layout, Menu } from 'antd';
import { Link, useLocation, useNavigate } from '@modern-js/runtime/router';
import './style.css'
import { useEffect, useMemo, useState } from 'react';
import idfcIcon from './../../../../public/logo.png'
import dahboardIcon from './../../../../public/drawer/Dashboard.svg'
import transactionIcon from './../../../../public/drawer/Transactions.svg'
import reportIcon from './../../../../public/drawer/Report.svg'
import searchIcon from './../../../../public/drawer/Search.svg'
import NotificationIcon from './../../../../public/drawer/Notifications.svg'



import dayjs from 'dayjs';
import { UserService } from '@/services/user';
import { LogoutOutlined } from '@ant-design/icons';
import { AuthService } from '@/services/auth';
import { TransactionDetailDrawer } from '@/components/global/transaction-details';
import { GlobalStore } from '@/stores/global';

const { Header, Sider } = Layout;


export const Dahsboardlayout = ({ children }: any) => {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState<any>(null);


  const fetchUser = () => {
    UserService.profile().then((res) => {
      setUser(res.data.data);
    }).catch((err) => {
      console.error(err);
    })
  }

  const a = (label: string, link?: any) => !!link
    ? <Link to={link} >{label}</Link>
    : <span>{label}</span>

  const dates = () => {
    let startD = dayjs().subtract(1, "day").format("YYYY-MM-DD")
    let endD = dayjs().format("YYYY-MM-DD")
    return `?startDate=${startD}&endDate=${endD}`
  }
  const dashboardDate = () => {
    let startD = dayjs().subtract(1, "day").format("YYYY-MM-DD")
    let endD = dayjs().format("YYYY-MM-DD HH:mm:ss")
    return `?start=${startD}&end=${endD}`
  }
  const reportDates = () => {
    let startD = dayjs().subtract(30, "day").format("YYYY-MM-DD")
    let endD = dayjs().format("YYYY-MM-DD")
    return `?startDate=${startD}&endDate=${endD}`
  }


  const links: any = [
    {
      label: a("Dashboard", `/`),
      key: "dashboard",
      icon: <img height={20} src={dahboardIcon} alt="ico" />
    },
    {
      label: a("Transactions"),
      key: "transactions",
      icon: <img height={20} src={transactionIcon} alt="ico" />,
      children: [
        { label: a("Manage Transactions", `/transactions/management${dates()}`), key: "transactions-management" },
        { label: a("Suspicious Transactions", `/transactions/suspecious${dates()}`), key: "transactions-suspecious" },
        { label: a("Disputed Transactions", `/transactions/dispute${dates()}`), key: "transactions-dispute" },
        { label: a("Bulk Check", `/transactions/bulk`), key: "bulk" },

      ]
    },
    {
      label: a("Reports"),
      key: "reports",
      icon: <img height={20} src={reportIcon} alt="ico" />,
      children: [
        { label: a("Report Chart", `/reports/charts`), key: "report-charts" },
        { label: a("MIS Report", `/reports/mis`), key: "reports-mis" },
      ],
    },
    {
      label: a("Search", '/search'),
      key: "search",
      icon: <img height={20} src={searchIcon} alt="ico" />,
    },
    {
      label: a("Notification", '/notification'),
      key: "notification",
      icon: <img height={20} src={NotificationIcon} alt="ico" />,

    }
  ]

  let selectedMap: any = {
    "/": "dashboard",
    "/transactions/management": "transactions-management",
    "/transactions/suspecious": "transactions-suspecious",
    "/transactions/dispute": "transactions-dispute",
    "/transactions/bulk": "bulk",
    "/reports/charts": "report-charts",
    "/reports/mis": "reports-mis",
    "/notification": "notification",
    "/search": "search"
  }

  const location = useLocation()

  const defaultOpened = useMemo(() => {
    let pathName = location.pathname
    if (pathName.includes("/transactions")) return ['transactions']
    if (pathName.includes("/reports")) return ['reports']
    return []
  }, [location])

  const defaultSelectedKeys = useMemo(() => {
    let pathName = location.pathname
    let val = selectedMap[pathName]
    return !!val ? val : ""
  }, [location])

  const navigate = useNavigate();

  const logout = () => {
    return AuthService.logout()
      .then((res) => {
        navigate("/auth/login")
      }).catch((err) => {
        console.error(err);
      })
  }

  useEffect(() => {
    fetchUser();
  }, [])
  return (
    <ConfigProvider
      theme={{
        token: {},
      }}
    >
      <Layout style={{
        minHeight: '100vh',
      }}
      >
        <Sider
          theme='dark'
          width={230}
          className='dahsboard-sider'
          collapsed={collapsed}
          onCollapse={(value: any) => setCollapsed(value)}
          style={{
            // background: "#ffffff",
            height: "100vh",
            zIndex: 3,
            position: "sticky",
            left: 0,
            top: 0,
            bottom: 0,
            overflow: "hidden",
            background: "#141414",
          }}
        >
          <Header style={{
            // padding: 0,
            // padding: "20px",
            position: "relative",
            height: "110px",
            background: "#141414"
          }} >
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              paddingTop: "20px"
            }}>

              <img src={idfcIcon} alt={'alt'} height={80} />


            </div>
          </Header>


          <div style={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "#141414"
          }}>
            <div style={{ color: "#fff", fontSize: "10px", paddingBottom: "10px" }}>Powered by Backspace Tech</div>
            <hr style={{ width: "70%", borderWidth: "1px" }} />
          </div>


          <div className='sidebar-menu-list'>
            <ConfigProvider
              theme={{
                token: {
                  // Seed Token
                  colorPrimary: '#525252ff',

                  // Alias Token
                  colorBgContainer: '#ffffffff',
                },
              }}
            >
              <Menu
                theme='dark'
                className='dashboard-sider-menu'
                // defaultSelectedKeys={[defaultSelectedKeys]}
                mode="inline"
                items={[...links,]}
                defaultOpenKeys={defaultOpened}
                selectedKeys={[defaultSelectedKeys]}
                style={{
                  background: "#141414",
                  fontWeight: '500',
                  height: "100vh",
                  position: "relative",
                  // top: "0px"
                }}
              />
            </ConfigProvider>
            <div style={{ height: "60px" }}></div>
          </div>
          {!!user ? <div style={{
            // background: "#505050",
            color: "#fff",
            position: "sticky",
            bottom: "0px",
            left: "0px",
            width: "100%",
            padding: "10px",
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              backgroundColor: "#141414",
            }}>
              <div style={{
                height: "40px",
                width: "40px",
                borderRadius: "100%",
                fontSize: "1rem",
                fontWeight: 500,
                backgroundColor: "gray",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>{String(user.user_name).split("")[0]}</div>
              <div style={{
                paddingLeft: "10px"
              }}>
                <div style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                  width: "100px",
                  whiteSpace: "nowrap",
                }} title={user.description}
                >{user.description}</div>
                <div>{user.customer_id}</div>
              </div>
              <div style={{ flex: 1 }}></div>
              <Button icon={<LogoutOutlined />} onClick={() => logout()}></Button>
            </div>
            {/* <div>
              <Button block icon={<LogoutOutlined />}>logout</Button>
            </div> */}
          </div> : <></>}
        </Sider>
        <Layout style={{ background: "#fff", }}>
          <div>
            {children}
            <GlobalStore.Provider>
              <TransactionDetailDrawer />
            </GlobalStore.Provider>
          </div>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}
